export const GET_PAGES = 'GET_PAGES'
// export const GET_BLOG = 'GET_BLOG'
export const GET_APP = 'GET_APP'
export const MODAL_CONTENT = 'MODAL_CONTENT'
export const SCROLLING = 'SCROLLING'
export const VIEW_DRAWER = 'VIEW_DRAWER'
export const VIEW_MODAL = 'VIEW_MODAL'
export const VIEW_TYPES = 'VIEW_TYPES'



// WEBPACK FOOTER //
// ./src/shared/store/mutation-types.js